'use strict';

export default function() {
    return {
        restrict: 'A',
        template: require('../../invest-activity/view/invest-activity-description-form.html'),
        scope: {
            project: '=myProject',
            readonly: '=myReadonly'
        },
        controller: [ "$scope", "InvestActivityService",
            function ($scope, InvestActivityService) {
                $scope.edit = edit;
                $scope.nextYear = nextYear;
                $scope.prevYear = prevYear;
                $scope.getPercent = getPercent;
                $scope.hasNextYear = hasNextYear;
                $scope.hasPrevYear = hasPrevYear;
                $scope.setSelectedYear = setSelectedYear;
                $scope.checkSelectedYear = checkSelectedYear;
                $scope.labels = ["-"];
                $scope.diagramData = [0,0,0,0];
                $scope.colors = ["#a9f10d", "#77cdff", "#ffbd59", "#cc9dfa"];
                $scope.data = {
                    productExchange: "-",
                    totalProducts: "-",
                    totalService: "-",
                    workPlaces: "-",
                    name: "-",
                };
                $scope.planFunds = [];
                $scope.selectedYear = 2023;
                $scope.diagramSum = 0;
                $scope.federalBudget = "-";
                $scope.areaBudget = "-";
                $scope.outbudget = '-';
                $scope.municipalityBudget = "-";
                $scope.initialData = null;
                $scope.yearIndex = -1;
                $scope.years = []
            
                // init();
            
                // function init() {}

                function loadData() {
                    $scope.data = {
                        name: $scope.project.investActivityArea ? $scope.project.investActivityArea.municipality.name || "-" : "-",
                      };
                      $scope.planFunds = ($scope.project.investActivityArea.planFunds || []).sort((a, b) => a.year - b.year);
                      $scope.years = $scope.planFunds.map(el => el.year);
                      $scope.initialData = $scope.project.investActivityArea;
                      if ($scope.years.length) {
                        $scope.selectedYear = $scope.years[0];
                        $scope.yearIndex = 0;
                      }
                      handleYearChange();
                }

                function hasNextYear() {
                    return $scope.years.length > $scope.yearIndex + 1;
                  }
              
                  function hasPrevYear() {
                    return $scope.yearIndex - 1 >= 0;
                  }
              
                  function nextYear() {
                    if (hasNextYear()) {
                      $scope.selectedYear = $scope.years[$scope.yearIndex + 1];
                      $scope.yearIndex += 1;
                    }
                    handleYearChange();
                  }
              
                  function prevYear() {
                    if (hasPrevYear()) {
                      $scope.selectedYear = $scope.years[$scope.yearIndex - 1];
                      $scope.yearIndex -= 1;
                    }
                    handleYearChange();
                  }
                  
                  function setSelectedYear(year) {
                      if (year == $scope.selectedYear || !$scope.years.includes(year)) return;
                      $scope.selectedYear = year;
                      $scope.yearIndex = $scope.years.indexOf(year);
                      handleYearChange();
                  }
              
                  function checkSelectedYear(year) {
                      return year == $scope.selectedYear ? true : false;
                  }
            
                  function handleYearChange() {
                    const planFundValue = $scope.planFunds.find(
                      (el) => el.year == $scope.selectedYear
                    );
              
                    if (planFundValue) {
                      $scope.diagramData = [
                        (planFundValue.federalBudget || 0),
                        (planFundValue.areaBudget || 0),
                        (planFundValue.municipalityBudget || 0),
                        (planFundValue.outbudget || 0),
                      ];
                      $scope.diagramSum = Number($scope.diagramData.reduce((acc, red) => acc + red, 0).toFixed(3));
                      $scope.federalBudget = planFundValue.federalBudget || 0;
                      $scope.areaBudget = planFundValue.areaBudget || 0;
                      $scope.municipalityBudget = planFundValue.municipalityBudget || 0;
                      $scope.outbudget = planFundValue.outbudget || 0;
                      $scope.labels = [
                        "Федеральный бюджет",
                        "Местный бюджет",
                        "Областной бюджет",
                        "Внебюджетные средства",
                      ];
              
                      $scope.productExchange = planFundValue.productExchange;
                      $scope.totalProducts = planFundValue.totalProducts;
                      $scope.toalService = planFundValue.toalService;
                      $scope.workPlaces = planFundValue.workPlaces;
                    } else {
                      $scope.diagramData = [0,0,0];
                      $scope.federalBudget = "-";
                      $scope.areaBudget = "-";
                      $scope.municipalityBudget = "-";
                      $scope.outbudget = "-";
                      $scope.diagramSum = 0;
                      $scope.labels = ["-"];
              
                      $scope.productExchange = "-";
                      $scope.totalProducts = "-";
                      $scope.toalService = "-";
                      $scope.workPlaces = "-";
                    }
                  }
            
                  function getPercent(type) {
                    const sum =
                      $scope.federalBudget + $scope.areaBudget + $scope.municipalityBudget + $scope.outbudget;
                    if (type === "federalBudget") {
                      const value = Math.round(($scope.federalBudget / sum) * 100);
                      return isNaN(value) ? "-" : value;
                    } else if (type === "areaBudget") {
                      const value = Math.round(($scope.areaBudget / sum) * 100);
                      return isNaN(value) ? "-" : value;
                    } else if (type === "municipalityBudget") {
                      const value = Math.round(($scope.municipalityBudget / sum) * 100);
                      return isNaN(value) ? "-" : value;
                    } else if (type === "outbudget") {
                      const value = Math.round(($scope.outbudget / sum) * 100);
                      return isNaN(value) ? "-" : value;
                    } else {
                      return "-";
                    }
                  }
            
                function edit() {
                    InvestActivityService.openEdit({
                    initialData: $scope.initialData,
                    planFunds: $scope.planFunds,
                    });
                }

                $scope.$watch('project.investActivityArea', function() {
                    if ($scope.project.investActivityArea) {
                        loadData()
                    }
                })
            },
        ]
    }
}
  